import { makeStyles } from "@material-ui/core/styles";
import { BAR_CHART_HEIGHT, LINE_CHART_HEIGHT, SELECTED_BORDER } from "./utils";

const useStyles = makeStyles((theme) => ({
  legendItem: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(0.5),
  },
  legendSwatch: {
    width: 12,
    height: 12,
    borderRadius: 2,
    marginRight: theme.spacing(0.5),
    flexShrink: 0,
  },
  chartSection: {
    marginBottom: theme.spacing(4),
  },
  chartHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
  },
  chartControls: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  viewToggle: {
    display: "flex",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
  },
  viewButton: {
    padding: theme.spacing(0.5),
    borderRadius: 0,
    minWidth: 36,
    "&:first-child": { borderRadius: "4px 0 0 4px" },
    "&:last-child": { borderRadius: "0 4px 4px 0" },
  },
  viewButtonActive: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  chartArea: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    height: BAR_CHART_HEIGHT,
    gap: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  barColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
    flex: 1,
    maxWidth: 120,
    height: "100%",
    cursor: "pointer",
    paddingBottom: 2,
    borderBottom: "3px solid transparent",
    transition: "border-color 0.2s ease",
    "&:hover": {
      borderBottomColor: theme.palette.grey[400],
    },
  },
  barColumnSelected: {
    borderBottomColor: `${SELECTED_BORDER} !important`,
  },
  barStack: {
    width: "100%",
    borderRadius: "4px 4px 0 0",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column-reverse",
    minHeight: 4,
  },
  forecastStack: {
    width: "100%",
    borderRadius: "4px 4px 0 0",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column-reverse",
  },
  barSegment: {
    width: "100%",
    minHeight: 2,
  },
  barLabel: {
    marginTop: theme.spacing(1),
    textAlign: "center",
  },
  barLabelSelected: {
    fontWeight: 700,
    color: SELECTED_BORDER,
  },
  barAmount: {
    marginBottom: theme.spacing(0.5),
    textAlign: "center",
    fontWeight: 500,
    fontSize: 11,
  },
  forecastAmount: {
    textAlign: "center",
    fontWeight: 500,
    fontSize: 10,
    color: theme.palette.text.secondary,
    fontStyle: "italic",
  },
  lineChartSvg: {
    width: "100%",
    height: LINE_CHART_HEIGHT,
  },
  lineChartDot: {
    cursor: "pointer",
    transition: "r 0.15s ease",
    "&:hover": {
      r: 7,
    },
  },
  monthRowClickable: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  monthRowSelected: {
    backgroundColor: `${theme.palette.primary.light}22 !important`,
  },
}));

export default useStyles;
